<template>

    <modal @closeModal="cancel" :show="show">

        <div class="flex-collumn padding-modal-da">

            <img class="foxie-sad" src="/img/foxy/sad.png">

            <h1 class="mda-title">{{ $t('settings_mailbox_delete') }}</h1>


            <span class="mda-text" v-html="computedStrModal"></span>

            <button class="btn btn-blue" @click="cancel">{{ $t('pop_up_delete_cta_cancel') }}</button>

            <button class="btn btn-white mda-top" @click="deleteAccount">{{ $t('pop_up_delete_cta_delete') }}
            </button>

        </div>

    </modal>

</template>

<script>

    import Vuex from 'vuex'

    import Modal from '@/components/modal/Modal'

    import Tag from '@/modules/tag'

    export default {

        name: 'modal-delete-account',

        components: {Modal},

        computed: {

            ...Vuex.mapGetters(['user']),

            computedStrModal() {

                const email = `<strong class='email-user' >${ this.email }</strong>`

                return this.user.accounts && this.user.accounts.length === 1 ? this.$tc('settings_mailbox_delete_description', 0, { mailbox: this.email }) : this.$tc('settings_mailbox_delete_description_multiple', 0, { mailbox: this.email })
            }

        },

        data() {
            return {
                show: false,
                email: ''
            }
        },

        methods: {

            open(email) {
                Tag.popupAll(this, 'delete_mailbox_confirmation')
                this.email = email
                this.show = true
            },

            closeModal(email = false) {
                this.$emit('close', email)
                this.show = false
            },

            cancel() {
                this.closeModal()
            },

            deleteAccount() {
                this.closeModal(this.email)
            }

        }

    }

</script>

<style scoped lang="scss">

    .mda-title {
        min-height: 24px;
        font-size: 21px;
        font-weight: bold;
        line-height: 1.14;
        color: $midnight;
        margin-top: 10px;
    }

    .mda-text {
        font-size: 16px;
        font-weight: 500;
        line-height: 1.5;
        color: $secur-text;
        margin: 10px 0 16px;
        text-align: center;
    }

    .foxie-sad {
        height: 125px;
        object-fit: contain;
        margin-top: 10px;
    }

    .mda-top {
        margin-top: 8px;
    }

    .padding-modal-da{
        padding: 15px 16px;
        @media screen and (min-width: $above-tablet-length) {
            max-width: 500px;
            padding: 15px 24px;
        }
    }

</style>
